export enum LookupType {
    None,
    Achievement,
    Currency,
    Decor,
    Illusion,
    Mount,
    Pet,
    Quest,
    Recipe,
    Reputation,
    Spell,
    Toy,
    Transmog,
    TransmogSet,
}
